import Pusher from "pusher-js";

// Single app-wide Pusher connection (same key/cluster as src/App.js).
//
// Why a singleton: creating a `new Pusher()` per subscription and calling
// `pusher.disconnect()` on cleanup tore the socket down while it was still
// connecting — in StrictMode effects mount→unmount→remount — which showed up
// as endless `connecting -> disconnected` and never reached `connected`.
// A shared instance stays connected for the app's lifetime; callers only
// bind/unbind their channels (the event-listener pattern that already works
// for `new.deployment` in App.js).
let instance = null;

export const getPusher = () => {
  if (!instance) {
    instance = new Pusher("5e9dcc6e9cd79dc83685", { cluster: "mt1" });
    // One connection-state log so the shared socket is verifiable in console.
    instance.connection.bind("state_change", (s) =>
      console.log(`[pusher] ${s.previous} -> ${s.current}`)
    );
    instance.connection.bind("error", (err) =>
      console.log("[pusher] connection error", err)
    );
  }
  return instance;
};

export default getPusher;
